const mimeTypes: Record<string, string> = {
  pdf: "application/pdf",
  png: "image/png",
  jpg: "image/jpeg",
  docx: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
};

const getMimeType = (filename: string): string => {
  const ext = filename.split(".").pop()?.toLowerCase() || "";
  return mimeTypes[ext] || "application/octet-stream";
};

export default getMimeType;
